function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 24.5V26.6875C17.5 27.4124 16.9124 28 16.1875 28H1.3125C0.587617 28 0 27.4124 0 26.6875V6.5625C0 5.83762 0.587617 5.25 1.3125 5.25H5.25V21.4375C5.25 23.1262 6.6238 24.5 8.3125 24.5H17.5ZM17.5 5.6875V0H8.3125C7.58762 0 7 0.587617 7 1.3125V21.4375C7 22.1624 7.58762 22.75 8.3125 22.75H23.1875C23.9124 22.75 24.5 22.1624 24.5 21.4375V7H18.8125C18.0906 7 17.5 6.40938 17.5 5.6875ZM24.1156 3.9906L20.5094 0.384398C20.2633 0.138273 19.9294 1.81998e-06 19.5814 0L19.25 0V5.25H24.5V4.91865C24.5 4.57057 24.3617 4.23674 24.1156 3.9906Z",
  fill: "#FFC300"
});
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.4c1d26a8b87eff6dd201bb97d59c375e.svg";
export { ForwardRef as ReactComponent };